import React from "react";
import ReactApexChart from "react-apexcharts";
import formations from "../../../CommonData/Data/formation";
import { events } from "../../../CommonData/Data";

const StepsTable = {
    series: [
        {
            name: "Erreurs Totales",
            data: formations.flatMap((formation) =>
                formation.stages.map((stage) => stage.erreursTotal)
            ),

        },
    ],
    options: {
        chart: {
            height: 350,
            type: "bar", // Type de graphique
            toolbar: {
                show: true,
            },
            events: {
                dataPointSelection: function (event, chartContext, config) {
                    const index = config.dataPointIndex; // Index du point sélectionné
                    const selectedId = events[index]?.id; // ID correspondant
                    if (selectedId) {
                        window.location.href = `/step/${selectedId}`;
                    }

                },
            },

        },

        plotOptions: {
            bar: {
                horizontal: false, // Barres verticales
                columnWidth: "50%",
                endingShape: "rounded",
            },
        },
        dataLabels: {
            enabled: false, // Pas d'étiquettes sur les points
        },
        xaxis: {
            categories: formations.flatMap((formation) =>
                formation.stages.map((stage) => stage.nom)
            ),
            title: {
                text: "Stages", // Titre de l'axe des X
            },
        },
        yaxis: {
            title: {
                text: "Erreurs Totales", // Titre de l'axe des Y
            },
        },
        colors: ["#0ab39c"], // Couleur des barres
    },
};

const StepGraph = () => {
    return (
        <div id="chart">
            <ReactApexChart
                options={StepsTable.options}
                series={StepsTable.series}
                type="bar"
                height={350}
            />
        </div>
    );
};

export default StepGraph;
